/**
 * NinjaSIM QC Fixes — ninjasim-fixes.js
 * Purpose: Fix accessibility and interactive behavior issues.
 * DO NOT: change content, design, or section order.
 */

(function () {
  'use strict';

  /* ---- 1. FAQ: Add aria-live for screen readers ---- */
  function fixFaqAccessibility() {
    var answers = document.querySelectorAll('.lp-faq__a');
    answers.forEach(function (el) {
      if (!el.hasAttribute('aria-live')) {
        el.setAttribute('aria-live', 'polite');
      }
    });

    /* Add aria-hidden to decorative FAQ icons */
    var faqIcons = document.querySelectorAll('.lp-faq__icon');
    faqIcons.forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---- 2. Add aria-hidden to all decorative SVG icons ---- */
  function fixDecorativeSvgs() {
    var selectors = [
      '.lp-hero__search-icon',
      '.lp-features__icon',
      '.lp-badges__icon',
      '.lp-trustbar__icon',
      '.lp-hiw__badge',
      '.lp-footer__payment svg'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ---- 3. Mobile drawer: Focus management ---- */
  function fixDrawerFocus() {
    var drawer = document.querySelector('.lp-drawer');
    if (!drawer) return;

    var closeBtn = drawer.querySelector('.lp-drawer__close');
    var hamburger = document.querySelector('.lp-header__hamburger');

    /* When drawer opens, focus the close button */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open') {
          if (drawer.hasAttribute('open') && closeBtn) {
            setTimeout(function () { closeBtn.focus(); }, 100);
          } else if (hamburger) {
            hamburger.focus();
          }
        }
      });
    });
    observer.observe(drawer, { attributes: true });
  }

  /* ---- 4. Search dropdown: Add aria-selected to active item ---- */
  function fixSearchAccessibility() {
    var searchInput = document.getElementById('lp-dest-search');
    if (!searchInput) return;

    searchInput.addEventListener('keydown', function () {
      /* After keydown is processed, update aria-selected */
      setTimeout(function () {
        var items = document.querySelectorAll('.lp-hero__search-item');
        items.forEach(function (item) {
          var isActive = item.classList.contains('active') ||
                         item.getAttribute('data-active') === 'true';
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }, 50);
    });
  }

  /* ---- 5. Cookie banner: Close on Escape key ---- */
  function fixCookieBannerKeyboard() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var banner = document.getElementById('ns-cookie-consent');
        if (banner && banner.style.display !== 'none') {
          if (typeof nsDismissCookies === 'function') {
            nsDismissCookies();
          }
        }
      }
    });
  }

  /* ---- Initialize all fixes ---- */
  function init() {
    fixFaqAccessibility();
    fixDecorativeSvgs();
    fixDrawerFocus();
    fixSearchAccessibility();
    fixCookieBannerKeyboard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
